import React, { useState, FC } from 'react';
import { Box, Button, CircularProgress, Typography } from '@material-ui/core';
import CustomInputNumber from '../../../../../components/input-number';
import { gweBillInquiryApi } from "../../../../../services/api/bill"
import { useDispatch, useSelector } from 'react-redux';
import { SetChargePackage } from '../../../../../redux/chargePackage/actions';
import { useHistory } from 'react-router-dom';

interface componentProps {
    text: string
    icon: any
}

const BillId: FC<componentProps> = ({ text, icon }) => {
    // --------- states
    const [loading, setLoading] = useState(false)
    const [formValue, setFormValue] = useState<any>({
        bill_code: undefined
    });
    const [formErr, setFormErr] = useState<any>({});
    //---------- end states

    // --------- variables
    const dispatch = useDispatch()
    const history = useHistory()
    const { info: { billType } } = useSelector(({ payment }: any) => payment)
    // --------- end variables

    // --------- useEffects

    // --------- end useEffects

    // --------- functions
    const handleFormValue = ({ target: { name, value } }: any) => {
        setFormValue({
            ...formValue,
            [name]: value,
        });
    };

    const validate = (submit: any) => {
        let _errors = {};
        let hasError = false;
        Object.keys(formValue).map((item: any) => {
            // @ts-ignore
            if (!formValue[item]) {
                _errors = { ..._errors, [item]: "این فیلداجباری است" };
                hasError = true;
            }
        });
        setFormErr(_errors);
        if (!hasError) submit();
    };

    const onSubmit = async () => {
        console.log('submit')
        setLoading(true)
        const res = await gweBillInquiryApi({
            ...formValue,
        })
        if (res) {
            dispatch(SetChargePackage({ ...formValue, ...res, billType }));
            history?.push("/billPayment")
        }
        setLoading(false)
    };
    // --------- end functions

    return (
        <div style={{ padding: '10px 30px 20px 30px' }}>
            {/* @ts-ignore */}
            <Box display={"flex"} justifyContent="center" alignItems="center" mb={2}>
                <img src={icon} alt="" className='headIcon' />
                <Typography>{text}</Typography>
            </Box>
            <hr />
            {/* @ts-ignore */}
            <Box display={"flex"} alignItems={"center"} mt={2}>
                <Typography className="text-muted text-right small" style={{ width: '100px' }}>
                    شناسه قبض
                </Typography>
                <CustomInputNumber
                    type={"number"}
                    name="bill_code"
                    variant="outlined"
                    className="w-100 my-3"
                    size="small"
                    onChange={handleFormValue}
                    value={formValue["bill_code"]}
                />
            </Box>
            <Typography className="textError">
                {formErr && formErr["bill_code"]}
            </Typography>

            <Button
                variant="contained"
                className="w-100 text-white typeBackground round-btn mt-4"
                size="large"
                onClick={() => validate(onSubmit)}
                disabled={loading ? true : false}
            >
                {loading ? <CircularProgress color="inherit" style={{ width: '20px', height: '20px', marginBottom: '-6px' }} /> : "استعلام"}
            </Button>
        </div>
    );
};

export default BillId;